import React from 'react';
import Datepicker from "react-tailwindcss-datepicker";

interface DateRangeValue {
  startDate: string | null;
  endDate: string | null;
}

interface DateRangePickerProps {
  value: DateRangeValue;
  onChange: (value: DateRangeValue) => void;
  placeholder?: string;
  disabled?: boolean;
  startLabel?: string;
}

export const DateRangePicker: React.FC<DateRangePickerProps> = ({ 
  value, 
  onChange, 
  placeholder = "Выберите период",
  disabled = false,
  startLabel = 'Период',
}) => {
  
  const handleDateChange = (newValue: any) => {
    if (!newValue) {
      onChange({ startDate: null, endDate: null });
      return;
    }

    const formattedValue = {
      startDate: newValue.startDate || null,
      endDate: newValue.endDate || null
    };
    
    onChange(formattedValue);
  };

  
  const datePickerValue = {
    startDate: (value?.startDate && value.startDate !== '') ? value.startDate : null,
    endDate: (value?.endDate && value.endDate !== '') ? value.endDate : null
  };

  return (
    <div className='px-5 pb-5'>
      <div className='mb-2'>
        <label className='block text-sm text-gray-700 mb-2'>{startLabel}</label>
        <Datepicker
          inputClassName="text-left cursor-default block w-full text-base rounded-md border border-[#DFE4EA] py-3 px-5 text-black outline-none shadow-custom disabled:cursor-not-allowed disabled:text-[#6B7280] disabled:bg-[#E5E7EB] translate-x-5"
          toggleClassName="absolute right-2 top-0 h-full px-3 text-gray-400 focus:outline-none disabled:cursor-not-allowed disabled:text-[#6B7280] disabled:bg-[#E5E7EB]"
          i18n="ru"
          primaryColor="blue"
          startWeekOn="mon"
          disabled={disabled}
          displayFormat="DD.MM.YYYY"
          useRange={false}
          value={datePickerValue}
          onChange={handleDateChange}
          placeholder={placeholder}
          containerClassName="relative z-10 -translate-x-5"

        />
      </div>
    </div>
  );
};